import { Column, Row, Spacer } from '@smuchile/pkg-unimarc-components'
import { getGlobalStyle } from '@smuchile/pkg-unimarc-components/helpers'
import { useOrderForm } from '@smuchile/pkg-unimarc-hooks'
import { useEffect, useState } from 'react'
import { CTAClearCart } from './CTAClearCart'
import { Shelves } from './Shelves'
import { Data } from '@smuchile/pkg-unimarc-hooks/shared/interfaces/IOrderForm'
import { TooltipAlcohol } from 'components/TooltipAlcohol'

export const ContainerMiniCart = (): React.ReactElement => {
  const { data, isLoading } = useOrderForm()
  const [alcoholLaw, setAlcoholLaw] = useState(false)

  const orderForm: Data = data?.data

  useEffect(() => {
    if (orderForm?.needIdentification) {
      setAlcoholLaw(true)
      setTimeout(() => {
        setAlcoholLaw(false)
      }, 5000)
    }
  }, [isLoading, orderForm?.needIdentification])
  return (
    <>
      <Row
        position='sticky'
        zIndex={getGlobalStyle('--z-index-5')}
      >
        {alcoholLaw && (
          <Column maxWidth='max-content'>
            <TooltipAlcohol
              onClose={() => {
                return setAlcoholLaw(false)
              }}
            />
          </Column>
        )}
      </Row>
      <Row
        backgroundColor={getGlobalStyle('--color-base-white')}
        borderRadius={getGlobalStyle('--border-radius-md')}
        boxShadow={getGlobalStyle('--box-shadow-2xs')}
        tagName='section'
      >
        <Column>
          <Row tagName='section'>
            <Column tagName='section'>
              <Shelves />
            </Column>
          </Row>
        </Column>
      </Row>
      <Spacer.Horizontal size={8} />
      <CTAClearCart />
    </>
  )
}
